import { Camera } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useOptionalClinicalCamera } from '@/components/camera/ClinicalCameraContext';

interface Props {
  /** Sidebar mobile aberta: some, pra não competir com o botão de dentro. */
  hidden?: boolean;
}

const PATIENT_FILE_RE = /^\/pacientes\/([^/?]+)/;

/**
 * FAB da "Câmera" no mobile — empilha na coluna da esquerda, acima do
 * "Ditar" (o Shell monta os dois numa pilha só, sem buraco quando um falta).
 *
 * Mesma regra do FAB do ditado: só aparece dentro da ficha de um paciente e
 * com permissão de anexar imagem. Abre direto a câmera traseira; a foto cai
 * no "Anexar imagens" daquele paciente.
 */
export const FloatingCameraButton = ({ hidden }: Props) => {
  const ctx = useOptionalClinicalCamera();
  const { pathname } = useLocation();

  if (!ctx || hidden) return null;
  if (!PATIENT_FILE_RE.test(pathname) || !ctx.available) return null;

  return (
    <button
      type="button"
      onClick={ctx.shoot}
      title="Tirar foto e anexar ao prontuário"
      aria-label="Câmera — tirar foto do paciente"
      className="relative w-12 h-12 rounded-full flex items-center justify-center shadow-xl transition-all bg-info text-white hover:brightness-110 ring-2 ring-info/30"
    >
      <Camera size={20} />
    </button>
  );
};
